import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import Dialog from '@material-ui/core/Dialog';
import { useMediaQuery, useTheme } from '@material-ui/core';
import Header from '../../components/Header';
import Items from './Items';
import Totals from './Totals';
import Modality from './Modality';
import Address from './Address';
import Payment from './Payment';
import Command from './Command';
import Send from './Send';

export default function Order() {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('xs'));
  const dispatch = useDispatch();

  const { company } = useSelector(state => state.data);
  const { modalOrder } = useSelector(state => state.order);
  const { modality } = useSelector(state => state.order.order || 0);
  const [number, setNumber] = useState('');

  useEffect(() => {
    if (modality <= 1) {
      setNumber('');
    }
  }, [modality]);

  function handleClose() {
    dispatch({ type: '@order/CLOSE' });
  }

  return (
    <Dialog fullScreen={fullScreen} maxWidth="xs" open={modalOrder}>
      <Header handleClose={handleClose} title="Pedido" />
      <div>
        <Items />
      </div>

      <div>
        <Totals />
      </div>

      <div>
        <Modality />
      </div>

      <div>
        <Address />
      </div>

      <div>
        <Payment />
      </div>

      {modality === 2 && company && company.auto && company.module === 'P' && (
        <div>
          <Command number={number} setNumber={setNumber} />
        </div>
      )}

      <div>
        <Send number={number} />
      </div>
    </Dialog>
  );
}
